import React from 'react';

const CompanyDetail: React.FC = () => {
  return <div>CompanyDetail</div>;
};

export default CompanyDetail;
